import * as React from "react";
import { useMemo } from "react";
import * as Immutable from "immutable";
import ExportTimerangeContext from "logview/components/contexts/ExportTimerangeContext";
import useLogViewLayout from "logview/hooks/useLogViewLayout";
const firstMessageTimestamp = (pages, timestampField) => {
  var _a;
  const [, oldestMessageChunk] = pages.first();
  const oldestMessage = oldestMessageChunk[oldestMessageChunk.length - 1];
  return (_a = oldestMessage == null ? void 0 : oldestMessage.message) == null ? void 0 : _a[timestampField];
};
const lastMessageTimestamp = (pages, timestampField) => {
  var _a;
  const [, newestMessageChunk] = pages.last();
  const newestMessage = newestMessageChunk[0];
  return (_a = newestMessage == null ? void 0 : newestMessage.message) == null ? void 0 : _a[timestampField];
};
const ExportTimerangeContextProvider = ({ children, pages, effectiveTimerange = void 0 }) => {
  const { timestampField } = useLogViewLayout();
  const exportTimerange = useMemo(() => {
    var _a, _b;
    const orderedPages = Immutable.Map(pages).map((value, key) => [Number(key), value]).toOrderedSet();
    const first = (_a = firstMessageTimestamp(orderedPages, timestampField)) != null ? _a : effectiveTimerange == null ? void 0 : effectiveTimerange.from;
    const last = (_b = lastMessageTimestamp(orderedPages, timestampField)) != null ? _b : effectiveTimerange == null ? void 0 : effectiveTimerange.to;
    return { first, last };
  }, [effectiveTimerange, pages, timestampField]);
  return /* @__PURE__ */ React.createElement(ExportTimerangeContext.Provider, { value: exportTimerange }, children);
};
export default ExportTimerangeContextProvider;
